import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { TransactionProvider } from "./context/TransactionContext";
import { SubscriptionProvider } from "./context/SubscriptionContext";
import { SettingsProvider } from "./context/SettingsContext";
import { Toaster } from "./components/ui/sonner";
import Layout from "./components/Layout";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import SettingsPage from "./pages/SettingsPage";
import PricingPage from "./pages/PricingPage";
import MonEntreprisePage from "./pages/MonEntreprisePage";
import ReportingFiscalPage from "./pages/ReportingFiscalPage";
import RentabilitePage from "./pages/RentabilitePage";
import FacturationPage from "./pages/FacturationPage";
import CRMPage from "./pages/CRMPage";
import CataloguePage from "./pages/CataloguePage";
import TresoreriePage from "./pages/TresoreriePage";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminPendingPage from "./pages/AdminPendingPage";
import DashboardPage from "./pages/DashboardPage";
import MonthPage from "./pages/MonthPage";
import "./App.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600"></div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

const PublicRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600"></div>
      </div>
    );
  }
  
  if (user) {
    return <Navigate to="/app" replace />;
  }
  
  return children;
};

const AdminRoute = ({ children }) => {
  const adminToken = localStorage.getItem('adminToken');
  
  if (!adminToken) {
    return <Navigate to="/admin/login" replace />;
  }
  
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SettingsProvider>
          <TransactionProvider>
            <SubscriptionProvider>
              <Routes>
                {/* Landing page publique */}
                <Route path="/" element={<LandingPage />} />
                
                {/* Auth routes */}
                <Route path="/login" element={
                  <PublicRoute>
                    <LoginPage />
                  </PublicRoute>
                } />
                <Route path="/register" element={
                  <PublicRoute>
                    <RegisterPage />
                  </PublicRoute>
                } />
                <Route path="/inscription" element={
                  <PublicRoute>
                    <RegisterPage />
                  </PublicRoute>
                } />
              <Route path="/reset-password" element={
                <PublicRoute>
                  <ResetPasswordPage />
                </PublicRoute>
              } />
              
              {/* Admin routes */}
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={
                <AdminRoute>
                  <AdminDashboard />
                </AdminRoute>
              } />
              <Route path="/admin/pending" element={
                <AdminRoute>
                  <AdminPendingPage />
                </AdminRoute>
              } />
              
              {/* App routes (protected) */}
              <Route path="/app" element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }>
                <Route index element={<DashboardPage />} />
                <Route path="mois/:mois" element={<MonthPage />} />
                <Route path="entreprise" element={<MonEntreprisePage />} />
                <Route path="fiscal" element={<ReportingFiscalPage />} />
                <Route path="rentabilite" element={<RentabilitePage />} />
                <Route path="facturation" element={<FacturationPage />} />
                <Route path="catalogue" element={<CataloguePage />} />
                <Route path="crm" element={<CRMPage />} />
                <Route path="tresorerie" element={<TresoreriePage />} />
                <Route path="parametres" element={<SettingsPage />} />
                <Route path="pricing" element={<PricingPage />} />
              </Route>
            </Routes>
            <Toaster position="top-right" richColors />
            </SubscriptionProvider>
          </TransactionProvider>
        </SettingsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
